import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Alert, Grid, Typography } from "@mui/material"
import queryString from "query-string"
import { AcademicLevel, Campus, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Dropdown, Email, InputText, PhoneNumber } from "components/fields"
import formations from "../services/formation"
import { useForms, useSalesforce } from "hooks"
import { campaigns, consent, consentement, defaultValues, getCampus } from "services"
import MentionsLegales from "components/MentionsLegales"
import { useState, useEffect } from "react"


const Form = ({
     optionsAcademicLevels, campMemberStatus }) => {
    const { recordTypeId, salesforce, setOpenSnackbar, setError } = useForms();
    const [isFormSent, setIsFormSent] = useState(false)
    const { campaignId: campaignIdParam, utm_id, campaignid, campaign_id } = queryString.parse(document.location.search)

  // Styles
  // Form
  const productId = 'ISEG_LP_PSUP_26'
   const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      lead: {
        ...defaultValues,
        ...consentement
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, reset, setValue } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'ISEG MCS',
      IONISSchool__c: 'ISEG MCS',
      LastForm__c: 'ISEG_LP_PSUP_26',
      LeadSource: 'LP : Demande de contact',
      RecordTypeId: recordTypeId
    }
    const finalLead = { ...lead, ...defaultDataLead }

    try {
      const createdLead = await salesforce.createLead(finalLead);
      if (!createdLead) {
        throw new Error('Lead non créé');
      }
      let campaignMember = {
        CampaignId: campaignId,
        LeadId: createdLead.Id,
        Status: campMemberStatus,
      }

        const recontactTask = {
          ActivityDate: new Date(),
          Description: "Le prospect souhaite être recontacté.",
          OwnerId: createdLead.OwnerId,
          Subject: "Recontacter le prospect",
          WhoId: createdLead.Id,
          Priority: 'High',
          Status: 'Not Started',
        };
        await salesforce.createTask(recontactTask);

      await salesforce.createCampaignMember(campaignMember)
      const externalId = campaignIdParam || utm_id || campaign_id || campaignid;
      if (externalId) {
        await salesforce.createCampaignMemberExternal(campaignMember, externalId)
      }
      const successUrl = new URL(window.location.href)
      successUrl.searchParams.set('sent', '1')
      window.history.replaceState({}, '', successUrl.toString())
      reset();
      setIsFormSent(true)
    }
    catch (error) {
      console.error('Erreur lors de la création du lead :', error?.response?.data ?? error)
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
    useEffect(() => {
      if (salesforce !== null && productId !== undefined) {
        const getData = async () => {
          const campaign = await salesforce.getCampaign(productId)
          return { campaign }
        }
        getData().then((value) => {
          const { campaign } = value
          setValue('campaignId', campaign.Id)
          // setOpenBackdrop(false)
        }).catch((error) => {
          setError('Une erreur est survenue lors du chargement du formulaire', error)
        })
      }
    }, [salesforce, productId, setError, setValue])

  useSalesforce('BusinessSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      {isFormSent ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Alert severity="success">
              <Typography variant="h6" gutterBottom>
                Merci pour ton intérêt.
              </Typography>
              <Typography>
                Tu seras recontacté sous peu pour échanger sur ton projet.
              </Typography>
            </Alert>
          </Grid>
        </Grid>
      ) : (
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel academics={['Terminale (BAC)', 'BAC', 'Bac +1', 'Bac +2', 'Autre']} options={optionsAcademicLevels} school="ISEG MCS" section={false} specialites={false} />
        <Grid item sm={6} xs={12}>
          <Campus label="Campus souhaité" options={getCampus('ISEG MCS')} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Dropdown control={control} label="Quel parcours t'intéresse ?" name="lead.Wished_Programm__c" options={formations} required />
        </Grid>
        <ConsentementMultiple />
        <RequiredFields />
        <Submit label="Je souhaite être recontacté" onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="ISEG MCS" />
      </Grid>
      )}
    </FormProvider>
  )
}

export default Form
